import axios from 'axios';

import type { TUpdateBatchInfosLocations } from '../../../types/TBatchUpdate';

export const updateBatchInfosLocations = async ({
  batchInfosLocationsId,
  userAccessToken,
  status,
  isUpdating,
  affectedTicketPlatforms,
}: TUpdateBatchInfosLocations): Promise<{
  status: 'ERROR' | 'SUCCESS';
  data: any;
}> => {
  try {
    if (isUpdating) isUpdating(true);

    const { data } = await axios.put(
      `${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/batch-infos-locations/${batchInfosLocationsId}`,
      {
        status,
        affected_platforms: affectedTicketPlatforms,
      },
      {
        headers: {
          Authorization: `Bearer ${userAccessToken}`,
        },
      },
    );

    return {
      status: 'SUCCESS',
      data,
    };
  } catch (err: any) {
    return {
      status: 'ERROR',
      data: err.response.data,
    };
  } finally {
    if (isUpdating) isUpdating(false);
  }
};
